import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, SectionHeader } from "../components/Card";

export function TechProfileScreen() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`/api/public/technicians/${id}`);
        const j = await r.json();
        setData(j);
      } catch {}
      setLoading(false);
    })();
  }, [id]);

  if (loading) return <Card><div style={{ textAlign: "center", padding: 40 }}>Loading…</div></Card>;
  if (!data?.technician) return <Card><div style={{ textAlign: "center", padding: 40 }}>Not found.</div></Card>;

  const t = data.technician;
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", paddingBottom: 80 }}>
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "30px 16px" }}>
        <header style={{ display: "flex", gap: 18, alignItems: "center", marginBottom: 24, flexWrap: "wrap" }}>
          <div style={{
            width: 96, height: 96, borderRadius: "50%",
            background: "linear-gradient(135deg, var(--mauve), var(--mauve-deep))",
            color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 36, fontWeight: 700,
          }}>
            {(t.profile?.full_name || "?").slice(0, 1).toUpperCase()}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h1 style={{ fontFamily: "var(--font-display)", color: "var(--text)" }}>
              {t.profile?.full_name || "Technician"}
            </h1>
            {data.averageRating != null && (
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
                <span style={{ color: "var(--gold)", fontSize: 18 }}>★</span>
                <span style={{ color: "var(--text)", fontWeight: 700 }}>{data.averageRating.toFixed(1)}</span>
                <span style={{ color: "var(--text-muted)", fontSize: 13 }}>· {data.reviewCount} review{data.reviewCount === 1 ? "" : "s"}</span>
              </div>
            )}
            {t.bio && <p style={{ color: "var(--text-soft)", marginTop: 10, lineHeight: 1.6 }}>{t.bio}</p>}
            {t.specialties?.length > 0 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10 }}>
                {t.specialties.map((s, i) => (
                  <span key={i} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 999, background: "var(--bg-soft)", color: "var(--text)" }}>{s}</span>
                ))}
              </div>
            )}
          </div>
        </header>

        <h2 style={{ fontFamily: "var(--font-display)", color: "var(--text)", marginBottom: 12 }}>Portfolio</h2>
        {data.portfolio.length === 0 ? (
          <Card><div style={{ textAlign: "center", color: "var(--text-muted)" }}>No completed work to show yet.</div></Card>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 12 }}>
            {data.portfolio.map((d, i) => (
              <article key={i} style={{ background: "var(--bg-elevated)", borderRadius: 14, overflow: "hidden", border: "1px solid var(--border)" }}>
                <img src={d.image_url} alt={d.name} loading="lazy"
                  style={{ width: "100%", aspectRatio: "1/1", objectFit: "cover", display: "block" }} />
                <div style={{ padding: 10 }}>
                  <div style={{ fontFamily: "var(--font-display)", fontSize: 14, fontWeight: 700, color: "var(--text)" }}>
                    {d.name}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

        {data.reviews.length > 0 && (
          <>
            <h2 style={{ fontFamily: "var(--font-display)", color: "var(--text)", margin: "30px 0 12px" }}>Reviews</h2>
            <div style={{ display: "grid", gap: 10 }}>
              {data.reviews.map((r, i) => (
                <article key={i} style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: 14, border: "1px solid var(--border)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <strong style={{ color: "var(--text)" }}>{r.customer?.full_name || "Customer"}</strong>
                    <span style={{ color: "var(--gold)" }}>{"★".repeat(r.rating)}</span>
                  </div>
                  {r.comment && <p style={{ marginTop: 6, color: "var(--text-soft)", fontSize: 13 }}>{r.comment}</p>}
                </article>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
